/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  query PlatformReadQuery {
    PlatformRead {
      generalSmtpConfiguration,
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
